/** Original MOMO cosmetics shared by loadout, replication and server validation. */
export const MOMO_EMOTES = [
 {idString:'momo_hello',name:'Signal hello'}, {idString:'momo_gg',name:'Good game'},
 {idString:'momo_hype',name:'Charged up'}, {idString:'momo_oops',name:'Oops'},
 {idString:'momo_love',name:'Squad love'}, {idString:'momo_loot',name:'Loot secured'},
 {idString:'momo_crown',name:'Crowned'}, {idString:'momo_salute',name:'Respect'}
] as const;
export const MOMO_BADGES = [
 {idString:'bdg_momo_pathfinder',name:'Pathfinder'}, {idString:'bdg_momo_tide',name:'Tide runner'},
 {idString:'bdg_momo_vanguard',name:'Vanguard'}, {idString:'bdg_momo_orbit',name:'Orbit'},
 {idString:'bdg_momo_crown',name:'Crown'}, {idString:'bdg_momo_wings',name:'Night wings'}
] as const;
export const MOMO_DEFAULT_EMOTES = ['momo_hello','momo_gg','momo_hype','momo_oops'] as const;
export const isMomoEmote = (id: string): boolean => MOMO_EMOTES.some(e => e.idString === id);
export const isMomoBadge = (id: string): boolean => MOMO_BADGES.some(b => b.idString === id);
export function canPreviewPremium(hostname: string): boolean {
 return ['127.0.0.1','localhost','[::1]'].includes(hostname);
}
